import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const EnvelopedDetails = styled.div`
    grid-column: 1 / -1;
    background-color: ${tokens.input.background};
    border-radius: 8px;
    padding: 0.2rem 0.8rem;
    margin: 0.4rem 0 0.8rem;
`;

export const EnvelopedRow = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;
    padding: 0.8rem 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${tokens.border.default};
    }
`;

export const EnvelopedLabel = styled.div`
    flex: 0 0 18rem;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 1.8rem;
`;

export const EnvelopedValue = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    line-height: 1.8rem;
`;
